export enum TenantStatus {
  Active = 'Active',
  Suspended = 'Suspended',
  Archived = 'Archived',
}

export enum LicenseStatus {
  Active = 'Active',
  Trial = 'Trial',
  Suspended = 'Suspended',
  Canceled = 'Canceled',
  Expired = 'Expired',
}

export enum ModuleTier {
  Basic = 'Basic',
  Gold = 'Gold',
  Premium = 'Premium',
}

export enum ModuleDatabaseStatus {
  Provisioning = 'Provisioning',
  Active = 'Active',
  Suspended = 'Suspended',
  Archived = 'Archived',
}

export enum ModuleEnvironment {
  Dev = 'Dev',
  Uat = 'Uat',
  Prod = 'Prod',
}

export enum SeatRole {
  Admin = 'Admin',
  Member = 'Member',
  Viewer = 'Viewer',
}

export enum SeatStatus {
  Active = 'Active',
  Deactivated = 'Deactivated',
}

export enum EntitlementOverrideType {
  Grant = 'Grant',
  Revoke = 'Revoke',
  TierOverride = 'TierOverride',
  LimitOverride = 'LimitOverride',
}

export enum AuditAction {
  TenantCreated = 'TenantCreated',
  TenantUpdated = 'TenantUpdated',
  TenantSuspended = 'TenantSuspended',
  TenantReactivated = 'TenantReactivated',
  LicenseIssued = 'LicenseIssued',
  LicenseRenewed = 'LicenseRenewed',
  LicenseSuspended = 'LicenseSuspended',
  LicenseCanceled = 'LicenseCanceled',
  LicenseUpgraded = 'LicenseUpgraded',
  ModuleCreated = 'ModuleCreated',
  ModuleUpdated = 'ModuleUpdated',
  ModuleTierChanged = 'ModuleTierChanged',
  FeatureCreated = 'FeatureCreated',
  PlanCreated = 'PlanCreated',
  PlanUpdated = 'PlanUpdated',
  DatabaseProvisioned = 'DatabaseProvisioned',
  DatabaseUpdated = 'DatabaseUpdated',
  DatabaseArchived = 'DatabaseArchived',
  SeatAssigned = 'SeatAssigned',
  SeatUnassigned = 'SeatUnassigned',
  SeatUpdated = 'SeatUpdated',
  OverrideCreated = 'OverrideCreated',
  OverrideDeleted = 'OverrideDeleted',
  UsageRecorded = 'UsageRecorded',
  WebhookProcessed = 'WebhookProcessed',
  EntitlementTokenMinted = 'EntitlementTokenMinted',
}
